<template>
  <div>
    <!-- 
      v-if="
        phoneList.find(
          (item) => window && window.navigator.userAgent.indexOf(item) >= 0
        )
          ? false
          : true
      " -->
    <div
      id="app"
      :style="{ 'min-width': !$route.meta.nozoom ? '1300px' : '0px' }"
    >
      <div style="display: none">聂章帅</div>
      <!-- <div class="bj"></div> -->

      <div id="app1" :style="{ zoom: !$route.meta.nozoom ? 0.8 : 1 }">
        <!-- <HLQHead
          v-if="
            !$route.meta.noShowHeader &&
            (!$route.query.type ||
              $route.query.type == 1 ||
              $route.path == '/registName') &&
            cityDetail.cityName == '华龙区'
          "
        /> -->
        <PYXQHead
          v-if="
            !$route.meta.noShowHeader &&
            (!$route.query.type ||
              $route.query.type == 1 ||
              $route.path == '/registName') &&
            cityDetail.cityName == '新乡市平原城乡一体化示范区'
          "
        ></PYXQHead>
        <Head
          v-else-if="
            !$route.meta.noShowHeader &&
            (!$route.query.type ||
              $route.query.type == 1 ||
              $route.path == '/registName')
          "
        ></Head>

        <!-- <div style="z-index: 1;" :class="{ maincontent: $route.meta.isShowHeader }"> -->
        <div
          style="z-index: 1"
          class="maincontent"
          v-if="!$route.meta.noShowHeader"
        >
          <div class="minHeight" style="min-height: 630px">
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive"></router-view>
          </div>
          <PYSFoot v-if="cityDetail.cityName == '濮阳市'" />
          <Foot v-else />
        </div>
        <router-view
          @initWebSocket="initWebSocket"
          v-if="$route.meta.noShowHeader"
        ></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '@/components/Header.vue'
import Head from '@/components/Head.vue'
import HLQHead from '@/components/HLQHead.vue'
import PYXQHead from '@/components/PYXQHead.vue'
import YQLJ from './components/Home/Third/友情链接'
import Foot from './components/Foot'
import PYSFoot from './components/Foot_濮阳市.vue'
import SCFoot from './components/SCFoot'
import HLQFoot from './components/HLQFoot'
import { cityDetail } from './util/mainOption'
import { mainReqUrl } from './util/mainReqUrl'
import { checkToken, getUserInfoByUserId } from './api/login'
export default {
  name: 'Home',
  components: {
    Header,
    Head,
    YQLJ,
    Foot,
    SCFoot,
    HLQHead,
    HLQFoot,
    PYXQHead,
    PYSFoot,
  },
  data () {
    return {
      phoneList: [
        'Android',
        'iPhone',
        'SymbianOS',
        'Windows Phone',
        'iPad',
        'iPod',
      ],
      lockReconnect: null,
    }
  },
  created () {
    console.log("document.title", document.title)
    document.title = cityDetail.toCityChangeTitle ?
      ((sessionStorage.getItem('deptName') ?
        sessionStorage.getItem('deptName') :
        cityDetail.cityName) + cityDetail.homeTitle) :
      (cityDetail.homeTitle ?
        cityDetail.cityName + cityDetail.homeTitle :
        cityDetail.cityName + "农村集体财产监督管理平台")
    // 检测访问设备如果是手机则重定向到别的地址
    let phoneList = [
      'Android',
      'iPhone',
      'SymbianOS',
      'Windows Phone',
      'iPad',
      'iPod',
    ];
    // 封装设置sessionstorage deptID:地区id
    (() => {
      sessionStorage.setItem(
        'deptId',
        window.location.hash.indexOf('?') >= 0
          ? window.location.hash.split('?')[1].indexOf('dm=') >= 0
            ? window.location.hash.split('?')[1].split('dm=')[1].indexOf('&') >=
              0
              ? window.location.hash.split('?')[1].split('dm=')[1].split('&')[0]
              : this.cityDetail.deptId
            : this.cityDetail.deptId
          : this.cityDetail.deptId
      )
      sessionStorage.setItem(
        'deptName',
        window.location.hash.indexOf('?') >= 0
          ? window.location.hash.split('?')[1].indexOf('deptName=') >= 0
            ? decodeURIComponent(
              window.location.hash.split('?')[1].split('deptName=')[1].split("&")[0]
            )
            : this.cityDetail.cityName

          : this.cityDetail.cityName
      )
      sessionStorage.setItem(
        'deptCode',
        window.location.hash.indexOf('?') >= 0
          ? window.location.hash.split('?')[1].indexOf('deptCode=') >= 0
            ? decodeURIComponent(
              window.location.hash.split('?')[1].split('deptCode=')[1].split("&")[0]
            )
            : this.cityDetail.deptCode

          : this.cityDetail.deptCode
      )
      localStorage.setItem('deptId', sessionStorage.getItem('deptId'))
      localStorage.setItem('deptName', sessionStorage.getItem('deptName'))
    })()
    // 身份验证 false验证失败后不重定向至登录页面
    checkToken().then(res => {
      if (res.data.code == 200) {
        this.$store.commit("initWebSocket")
      }
    })
  },
  mounted () {

  },
  methods: {
    initWebSocket () {
      this.$store.commit("initWebSocket")
    },
  },
}
</script>
<style>
@import "./util/quill.core.css";

div,
p,
ul,
li,
ol,
dl,
dt,
dd,
span,
strong,
em,
i,
b,
img,
form,
h1,
h2,
h3,
h4,
h5,
h6,
input,
fieldset,
legend,
optgroup,
select,
table,
textarea,
blockquote {
  margin: 0;
  padding: 0;
}

* {
  margin: 0;
  padding: 0;
}

html {
  -moz-transform: scale(1, 0.7);
  -moz-transform-origin: center top;
}

body {
  margin: 0;
  padding: 0;
}

img {
  border: 0;
  vertical-align: middle;
  max-width: 100%;
  width: auto;
  height: auto;
}
.searchDiv {
  display: flex;
  justify-content: end;
}
a {
  text-decoration: none;
  color: black;
}

.l {
  float: left;
}

.r {
  float: right;
}

#app {
  position: relative;
  width: 100%;
  height: auto;
  margin: 0 auto;
  /* background-color: pink; */
  /* padding-top: 50px; */
  /* overflow-x: hidden; */
  /* padding: 594px 0 152px 0; */

  /* background-size:100% 17.6%; */
  background-position: top center;
  /* background-attachment: fixed; */
  /* padding-top: 326px; */

  /* z-index: 1; */
}

#app /deep/.el-input {
  font-size: 22px;
  /* border: 1px solid red; */
}

.el-input__icon {
  line-height: 50px;
  width: 40px;
  cursor: pointer;
}
/* 分页 */
.el-pagination .el-pager li {
  font-size: 20px;
}
.ql-align-center {
  text-align: center;
}
.el-pagination button,
.el-pagination span:not([class*="suffix"]) {
  font-size: 20px !important;
}

.maincontent {
  //margin-top: 250px;
}

.showheader {
  padding-top: 410px;
  color: red;
}

.bj {
  width: 100%;
  height: 150px;
  position: fixed;
  top: 0;
  left: 0;
  background-position: top center;
  /* z-index: 999; */
}

#app1 {
  /* transform: scale(0.8,0.8); */
  /* width: 80%; */
  /* margin:0 auto; */

  //transform: scale(0.8, 0.8);
  -moz-transform: scale(0.7, 1);
  -moz-transform-origin: center top;
  /* position: fixed; */
  position: relative;
}

.minHeight {
  min-height: 600px;
}

.minHeight > div {
  /* min-height: 600px */
}
</style>
